import './PerksAndBenefits.scss';

class PerksAndBenefits {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['PerksAndBenefits'] = PerksAndBenefits;
export default PerksAndBenefits;
